import React, { ReactNode } from "react";
import {
  Popover,
  PopoverBackdrop,
  PopoverButton,
  PopoverPanel,
} from "@headlessui/react";
import classNames from "classnames";
import { Link } from "react-router-dom";

interface MobileNavLinkProps {
  href: string;
  children: ReactNode;
}

interface MobileNavIconProps {
  open: boolean;
}

export const MobileMenu: React.FC = () => {
  const MobileNavLink: React.FC<MobileNavLinkProps> = ({ href, children }) => {
    return (
      <PopoverButton
        as={Link}
        to={href}
        className="block text-center w-full p-2"
      >
        {children}
      </PopoverButton>
    );
  };

  const MobileNavIcon: React.FC<MobileNavIconProps> = ({ open }) => {
    return (
      <svg
        aria-hidden="true"
        className="h-3.5 w-3.5 overflow-visible stroke-slate-700"
        fill="none"
        strokeWidth={2}
        strokeLinecap="round"
      >
        <path
          d="M0 1H14M0 7H14M0 13H14"
          className={classNames(
            "origin-center transition",
            open && "scale-90 opacity-0"
          )}
        />
        <path
          d="M2 2L12 12M12 2L2 12"
          className={classNames(
            "origin-center transition",
            !open && "scale-90 opacity-0"
          )}
        />
      </svg>
    );
  };

  return (
    <Popover>
      <PopoverButton
        className="relative z-10 flex h-8 w-8 items-center justify-center ui-not-focus-visible:outline-none"
        aria-label="Toggle Navigation"
      >
        {({ open }) => <MobileNavIcon open={open} />}
      </PopoverButton>
      <PopoverBackdrop
        transition
        className="fixed inset-0 bg-slate-300/50 duration-150 data-[closed]:opacity-0 data-[enter]:ease-out data-[leave]:ease-in"
      />
      <PopoverPanel
        transition
        className="absolute inset-x-0 top-full mt-4 flex origin-top flex-col rounded-2xl bg-white p-4 text-lg tracking-tight text-slate-900 shadow-xl ring-1 ring-slate-900/5 data-[closed]:scale-95 data-[closed]:opacity-0 data-[enter]:duration-150 data-[leave]:duration-100 data-[enter]:ease-out data-[leave]:ease-in"
      >
        <MobileNavLink href="/">Inicio</MobileNavLink>
        <MobileNavLink href="/floradibuja">Conoceme</MobileNavLink>
        <MobileNavLink href="/social">Redes sociales</MobileNavLink>
        <MobileNavLink href="/solicitudPresupuesto">
          Solicitar presupuesto
        </MobileNavLink>
      </PopoverPanel>
    </Popover>
  );
};
